/* eslint-disable react/display-name */
import * as React from 'react';
import { AudienceList } from '../../components/audiences/AudienceList';
import { AudienceListPageStateSetter } from '../state-setter/AudienceListPageStateSetter';
import { AudiencePageStateSetterProps } from '../state-setter/AudiencePageStateSetterBase';

export const AudienceListPage: any = class extends React.PureComponent<AudiencePageStateSetterProps> {
	public render() {
		return (
			<>
				<AudienceList />
				<AudienceListPageStateSetter {...this.props} />
			</>
		);
	}
};
